<template>
  <v-card class="c-overview">
      <v-row no-gutters class="c-overview__header">
        <v-col cols="12" md="6">
          <span class="c-overview__title">Overview</span>
          <span class="c-overview__hint">(total parc machine)</span>
        </v-col>
        <v-col cols="12" md="6">
          <period-selector
            light
          ></period-selector>
        </v-col>
      </v-row>

      <v-row no-gutters class="c-overview__items" justify="center">
        <v-col cols="4" md="2" v-for="item in counts" :key="item.label">
          <overview-item
            :src="item.src"
            :label="item.label"
            :value="item.value"
          ></overview-item>
        </v-col>
      </v-row>
  </v-card>
</template>

<script>
import OverviewItem from '@/components/OverviewItem';
import PeriodSelector from '@/components/PeriodSelector';

import PeriodListener from '@/mixins/PeriodListener';
import RoleFiltering from '@/mixins/RoleFiltering';

import { STATS_GET_COUNT } from '@/store/actions/stats';
import { BOTTLE_VOLUME } from '@/store/modules/stats';


export default {
  name: 'Overview',

  mixins: [
    PeriodListener,
    RoleFiltering
  ],

  components: {
    OverviewItem,
    PeriodSelector
  },

  data: () => ({
    loading: false
  }),

  computed: {
    counts () {
      const count = this.$store.state.stats.count;

      let adminItems = [];

      if (this.hasRole('admin')) {
        adminItems.push({
          label: 'Clients',
          src: require('@/assets/establishment_icon.png'),
          value: count.clients
        });
      }

      let genericItems = [
        {
          label: 'Machines',
          src: require('@/assets/machine_empty_icon.png'),
          value: count.machines
        },
        {
          label: 'Litres consommés',
          src: require('@/assets/L-icon.png'),
          value: count.volume / 100
        },
        {
          label: 'Bouteilles',
          src: require('@/assets/wine_bottle_icon.png'),
          value: count.volume / BOTTLE_VOLUME
        },
        {
          label: 'Verres',
          src: require('@/assets/glass_icon.png'),
          value: count.glasses
        },
        {
          label: 'Carafes',
          src: require('@/assets/pitcher_icon.png'),
          value: count.pitchers
        }
      ];

      return [].concat(adminItems, genericItems);
    }
  },

  mounted () {
    this.fetchData();
  },

  methods: {
    fetchData () {
      this.loading = true;

      this.$store.dispatch(STATS_GET_COUNT)
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.c-overview {
  background-color: lightgray;
  color: #4a4a4a;

  &__header {
    padding: 20px;
  }

  &__title {
    font-weight: bold;
    text-transform: uppercase;
  }

  &__hint {
    font-style: italic;
  }
}
</style>
